import React from 'react';

const SchemaOrg = ({ model }) => {
    if (!model) return null;

    return (
        <script type="application/ld+json">
            {JSON.stringify(model)}
        </script>
    );
};

export default SchemaOrg;
